import { Component, Input } from '@angular/core';
import { Microphone } from 'src/app/shared/models/microphone.model';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-microphone',
  templateUrl: './microphone.component.html',
  styleUrls: ['./microphone.component.scss'],
})
export class MicrophoneComponent {
  @Input() microphone: Microphone;
  @Input() showText: boolean;

  constructor(
    private toastrService: ToastrService,
    private translocoService: TranslocoService
  ) {}

  onMicrophoneClick(event: MouseEvent) {
    event.stopPropagation();
    (event.target as HTMLElement).blur();
    this.microphone.isMuted = !this.microphone.isMuted;
    const translationKey = this.microphone.isMuted
      ? 'pages.speech-service.microphone.mute_success'
      : 'pages.speech-service.microphone.unmute_success';

    this.translocoService
      .selectTranslate(translationKey, { name: this.microphone.name })
      .subscribe((translation) => {
        this.toastrService.success(
          translation,
          undefined,
          { timeOut: 1500 }
        );
      });
  }
}
